import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getRoles = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/roles/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Roles fetch error:", error);
    throw error;
  }
};

const createRole = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/roles/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Role create error:", error);
    throw error;
  }
};

const deleteRole = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin/roles/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Role delete error:", error);
    throw error;
  }
};

const updateRolePageAccess = async (id, pageAccess) => {
  try {
    const token = getToken();

    const res = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}admin/roles/page-access/?id=${id}`,
      { page_access: pageAccess },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Role page access update error:", error);
    throw error;
  }
};

export { getRoles, createRole, deleteRole, updateRolePageAccess };
